<wr-base-dialog status="primary"
                header="Reparaturauftrag erstellen"
                submitText="Weiter zur E-Mail"
                dialogWidth="large"
                [disableSubmit]="form.invalid"
                [submitResponse]="submitResponse">
  <form [formGroup]="form" data-cy="repair-task-create-form">
    <hau-form-field label="Dienstleister">
      @if (loading()) {
        <nb-spinner size="small"></nb-spinner>
      } @else {
        <div class="contractor-field">
          @if (options().length) {
            <nb-select fullWidth
                       placeholder="Dienstleister auswählen"
                       formControlName="contractorId"
                       data-cy="repair-task-contractor-select">
              @for (option of options(); track option.id) {
                <nb-option [value]="option.id">{{ option.name }}</nb-option>
              }
            </nb-select>
          } @else {
            <wr-banner [icon]="{ icon: 'alert-triangle-outline', pack: 'eva' }"
                       status="warning"
                       data-cy="repair-task-no-contractor"
                       [message]="emptyContractorMessage"></wr-banner>
          }
          @if (buildingId) {
            <wr-repair-task-contractor-hint [buildingId]="buildingId"></wr-repair-task-contractor-hint>
          }
        </div>
      }
    </hau-form-field>
    <hau-form-field label="Titel">
      <input nbInput fullWidth formControlName="title" data-cy="repair-task-title">
    </hau-form-field>
    <hau-form-field label="Beschreibung">
      <textarea nbInput fullWidth rows="5" formControlName="description" data-cy="repair-task-description"></textarea>
    </hau-form-field>
  </form>
</wr-base-dialog>
